import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  PageDialogCloseButton: {
    backgroundColor: theme.palette.customColor.BGLIGHT,
    color: theme.palette.customColor.PRIMARY,
    "&:hover": {
      backgroundColor: theme.palette.customColor.BGLIGHT,
      color: theme.palette.customColor.PRIMARY,
    },
    minWidth: "130px",
    marginRight: "20px",
    border: `1px solid ${theme.palette.customColor.PRIMARY}`,
    textTransform: "capitalize",
  },
  PageDialogDoneButton: {
    backgroundColor: theme.palette.customColor.PRIMARY,
    color: theme.palette.customColor.LIGHT,
    "&:hover": {
      backgroundColor: theme.palette.customColor.PRIMARY,
      color: theme.palette.customColor.LIGHT,
    },
    minWidth: "130px",
    textTransform: "capitalize",
  },
  createPagePopupLeft: {
    padding: "17px 30px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%",
    [theme.breakpoints.down("md")]: {
      padding: "15px",
    },
  },
  createPagePopuprowBox: {
    margin: "13px 0",
  },
  createPagePopupButtonWp: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    margin: "13px 0",
    "& button": {
      width: "50%",
      height: "47px",
      "&:first-child": {
        marginRight: "15px",
      },
    },
  },
  createPagePopupRight: {
    background: theme.palette.customColor.ACCENTS.ACCENT_5,
    minHeight: "450px",
    [theme.breakpoints.down("md")]: {
      minHeight: "auto",
    },
  },
  popupRightImage: {
    display: "flex",
    height: "100%",
    alignItems: "center",
    justifyContent: "flex-end",
    [theme.breakpoints.down("md")]: {
      padding: "25px 0px 25px 25px",
    },
  },
}));
